import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import IconFacebook from "../svgs/IconFacebook.svg";
import IconInstagram from "../svgs/IconInstagram.svg";

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer__row">
        <StaticImage
          className="footer__logo"
          src="../images/logo.png"
          alt="Plush Oxford logo"
        />
        <div className="footer__social_icons">
          <a
            href="https://www.facebook.com/plushoxford/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconFacebook />
          </a>
          <a
            href="https://www.instagram.com/plushoxford/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconInstagram />
          </a>
        </div>
        <div className="footer__contact">
          <b>Contact us</b>
          <a className="animated_link" href="mailto:director@plushoxford.com">
            director@plushoxford.com
          </a>
        </div>
      </div>
      <div className="footer__row">
        <small>© Plush Oxford {new Date().getFullYear()}</small>
        {/* TODO: Don't have content for these */}
        {/* <small>
          <a>Privacy Policy</a> • <a>Terms &amp; Conditions</a>
        </small> */}
      </div>
    </footer>
  );
}
